import { render, staticRenderFns } from "./PegasusProvider.vue?vue&type=template&id=761cadbc&scoped=true"
import script from "./PegasusProvider.vue?vue&type=script&lang=js"
export * from "./PegasusProvider.vue?vue&type=script&lang=js"
import style0 from "./PegasusProvider.vue?vue&type=style&index=0&id=761cadbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761cadbc",
  null
  
)

export default component.exports